import { render, staticRenderFns } from "./WavyCard.vue?vue&type=template&id=ea3f5ba0&"
import script from "./WavyCard.vue?vue&type=script&lang=js&"
export * from "./WavyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports